!function() {

  UC.views.StaticPagesForAttorneys = Backbone.View.extend({

    initialize: function() {
    }
  });
}();
